module.exports = __webpack_public_path__ + "static/media/Tamesha Logan Headshot.e055a389.jpeg";